module.exports = __webpack_public_path__ + "static/img/vampire_ekimmara.ef4bd00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/vampire_ekimmara.png
// module id = CyaM
// module chunks = 0